import React from "react";
import { DocumentMatchStatus } from "@common/types/matchStatus";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const options: FilterMultiselectOption[] = [
    {
        value: DocumentMatchStatus.MATCHED,
        label: "Matched",
        searchableLabel: "matched",
    },
    {
        value: DocumentMatchStatus.NOT_MATCHED,
        label: "Not matched",
        searchableLabel: "not matched",
    },
];

export const MatchStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.matchStatuses ?? [];
    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) =>
                    onChange({
                        matchStatuses:
                            val.length > 0
                                ? (val as DocumentMatchStatus[])
                                : undefined,
                    })
                }
                name="matchStatuses"
                onBlur={noop}
            />
        </div>
    );
};
